module.exports = __webpack_public_path__ + "img/pwa-role-bind.9fd673b1.png";